import {Component, HostListener, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import {Router} from "@angular/router";
import { selectRecipient } from '../../../state/selectors/selector';
import { ButtonComponent } from '@vg-constellation/angular-19/button';
import { IconModule } from '@vg-constellation/angular-19/icon';
import { AsyncPipe, CommonModule } from '@angular/common';
import { InternalCalloutComponent } from '@vg-constellation/angular-19/internal-callout';
import { StepIndicatorComponent } from '../../step-indicator/step-indicator.component';
import { CaasService } from '../../../services/caas/caas.service';

interface Recipient {
  confirmationId: string;
  interestedParty: boolean;
  confirmationDate: string;
  description: string;
  mediaTypeOnFile: string;
  duplicateMediaType: string;
  name: string;
  address: string;
}

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  imports: [
    CommonModule,
    ButtonComponent,
    IconModule,
    AsyncPipe,
    InternalCalloutComponent,
    StepIndicatorComponent,
  ],
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit{
  isSmallScreen: boolean;
  recipient$: Observable<Recipient>;
  currentStepIndicatorIndex$: Observable<number>;
  content: any;

  constructor(
    private store: Store<{ stepIndicatorIndex: number }>,
    private router: Router,
    private caasService: CaasService
  ) {
    this.currentStepIndicatorIndex$ = this.store.select('stepIndicatorIndex');
    this.recipient$ = this.store.select(selectRecipient);
  }
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.checkScreenSize();
    this.content = this.caasService.getPageContent()?.confirmationJourneyContent;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 576; // Small screen size max width is 576px
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }

  getStepText(stepNumber: number): string {
    const template = this.content?.stepProgressTemplate || 'Step ${step-number} of 3';
    return template.replace('${step-number}', String(stepNumber));
  }

}
